export default "__VITE_ASSET__e2093090__"